const Playlist = (target) => {

  const isOutOfViewport = (el) => {
    const rect = el.getBoundingClientRect();

    return (
      rect.bottom < 0 ||
      rect.right < 0 ||
      rect.left > window.innerWidth ||
      rect.top > window.innerHeight
    );
  }

  const initPlaylist = el => {
    const iframe = el.querySelector('iframe');
    const overlay = el.querySelector('.video-plyr__overlay');
    const poster = el.querySelector('.playlist__poster');

    el.addEventListener('click', function() {
      iframe.src = iframe.dataset.src;
      iframe.classList.remove('hidden');
      overlay.classList.add('hidden');
      poster.classList.add('hidden');
    });

    window.addEventListener('scroll', function() {
      if (isOutOfViewport(el)) {
        iframe.src = '';
        iframe.classList.add('hidden');
        overlay.classList.remove('hidden');
        poster.classList.remove('hidden');
      }
    });
  }

  $('body').find(target)
    .each((_, el) => {
      initPlaylist(el);
    });
}

export default Playlist;



// WEBPACK FOOTER //
// ./scripts/components/Playlist.js